import React from "react";
import { useTranslation } from "react-i18next";
import { AssetCategory } from "velavu-js-api";
import { CategoryTag } from "../../../../elements/categorization-tag";
import { VelavuMenuFilterItem } from "../../../../elements/velavu-menu-filter";
import * as styles from "./asset-list-filter.module.scss";

interface AssetListFilterProps {
	filterCategory: AssetCategory | undefined;
	selectCategory: (filter: AssetCategory | undefined) => void;

	filterStatus: boolean | undefined;
	selectStatus: (filter: boolean | undefined) => void;
}

export default function AssetListFilter(props: AssetListFilterProps) {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<div className={styles.column}>
				<div className={styles.title}>
					{t("dashboard.filters.status")}
				</div>
				<VelavuMenuFilterItem
					checked={props.filterStatus === undefined}
					onClick={() => props.selectStatus(undefined)}
				>
					{t("dashboard.filters.all")}
				</VelavuMenuFilterItem>
				<VelavuMenuFilterItem
					checked={props.filterStatus === true}
					onClick={() => props.selectStatus(true)}
				>
					{t("connection_status.active")}
				</VelavuMenuFilterItem>
				<VelavuMenuFilterItem
					checked={props.filterStatus === false}
					onClick={() => props.selectStatus(false)}
				>
					{t("connection_status.inactive")}
				</VelavuMenuFilterItem>
			</div>

			<div className={styles.column}>
				<div className={styles.title}>
					{t("dashboard.filters.category")}
				</div>
				<VelavuMenuFilterItem
					checked={props.filterCategory === undefined}
					onClick={() => props.selectCategory(undefined)}
				>
					{t("dashboard.filters.all")}
				</VelavuMenuFilterItem>
				{Object.values(AssetCategory).map(
					(assetCategory: AssetCategory) => (
						<VelavuMenuFilterItem
							key={assetCategory}
							checked={props.filterCategory === assetCategory}
							onClick={() => props.selectCategory(assetCategory)}
						>
							<CategoryTag category={assetCategory} />
						</VelavuMenuFilterItem>
					),
				)}
			</div>
		</div>
	);
}
